export default __webpack_public_path__ + "static/media/network.845664d6.svg";